import PageSize from "./PageSize";
import Pagination from "./Pagination";
import React from "react";
import { IItemList } from "../core/Select";
import classes from "./pageActions.module.css";

interface IProps {
  pageSize: string | null;
  pageSizeList: IItemList[];
  page: number;
  pageCount: number;
  itemsCount: number;
  setPageSize: (value: string | null) => void;
  setPage: (value: number) => void;
}

const PageActions = ({ pageSize, pageSizeList, page, pageCount, itemsCount, setPageSize, setPage }: IProps) => {
  return (
    <div className={classes.pageActions}>
      <PageSize
        pageSize={pageSize}
        pageSizeList={pageSizeList}
        page={page}
        itemsCount={itemsCount}
        onChange={setPageSize}/>
      <Pagination count={pageCount} current={page} onChange={setPage}/>
    </div>
  );
};

export default PageActions;
